import MainLayout from "screens/partials/layout";
import StorboltHelpComponent from "screens/partials/help";

export default function Help() {
    return (
        <MainLayout>
            <StorboltHelpComponent />
        </MainLayout>
    )
}
